import { Prisma } from "@prisma/client";

export const activityRequestValues =
  Prisma.validator<Prisma.ActivityProgramRequestDefaultArgs>()({
    include: {
      activity: {
        include: {
          structure: {
            include: {
              businessSectorRelation: true,
            },
          },
          activityArea: true,
          schedules: {
            orderBy: [
              {
                timetable: {
                  day: "asc",
                },
              },
              {
                timetable: {
                  startHour: "asc",
                },
              },
            ],
            include: {
              timetable: true,
            },
          },
        },
      },
      event: true,
    },
  });

export type ActivityProgramRequestType =
  Prisma.ActivityProgramRequestGetPayload<typeof activityRequestValues>;
